import { ru, type Messages } from './ru.js';

export type { Messages };

const BY_LANG: Record<string, Messages> = { ru };

/** Dictionary for a language; Russian when the language is unknown or not given. */
export function messages(lang?: string | null): Messages {
  return (lang && BY_LANG[lang]) || ru;
}
